<template>
  <div class="choice_consultant">
    <div class="consultant">
      <span>置业顾问</span>
      <span class="choice" @click="showPopup"
        >{{ name }}&nbsp;&nbsp;<van-icon name="arrow" class="ico"
      /></span>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%', width: '100%', overflowY: 'auto' }"
      round
    >
      <div class="header">
        <span @click="cancle">取消</span>
        <span>选择置业顾问</span>
        <span @click="handleChoice">确定</span>
      </div>

      <van-row>
        <van-col
          class="managerName"
          span="7"
          :class="{ ch: categoryIndex === index }"
          v-for="(item, index) in infor"
          :key="index"
          @click="choiceConsultant(item, index)"
        >
          {{ item.managerName }}</van-col
        >
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Icon, Col, Row } from "vant";
export default {
  props: {
    projectCode: {
      type: [Number, String],
    },
    adviserName: {
      type: [String],
    },
  },
  data() {
    return {
      show: false,
      infor: [],
      categoryIndex: "",
      name: "请选择置业顾问",
      personData: "",
    };
  },
  created() {
    this.$api.advi({ projectCode: this.projectCode }).then((res) => {
      this.infor = res.body;
    });
    this.name = this.adviserName ? this.adviserName : "请选择置业顾问";
  },
  components: {
    "van-popup": Popup,
    "van-icon": Icon,
    "van-row": Row,
    "van-col": Col,
  },
  methods: {
    //弹出置业顾问弹框
    showPopup() {
      if (!this.adviserName) {
        this.show = true;
      }
    },
    //取消弹框
    cancle() {
      this.show = false;
    },

    //置业顾问确定按钮
    handleChoice() {
      this.show = false;

      if (this.personData !== "") {
        this.name = this.personData.managerName;
        this.$emit("getCode", this.personData);
      }
    },
    //选择置业顾问
    choiceConsultant(v, index) {
      this.categoryIndex = index;
      this.personData = v;
    },
  },
};
</script>

<style lang="scss" scoped>
.choice_consultant {
  width: 100%;
  .consultant {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 100px;
    border-bottom: 1px solid rgba(244, 245, 245, 1);
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
    .choice {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      .ico {
        display: inline-block;
      }
    }
  }
  .header {
    position: sticky;
    top: 0px;
    display: flex;
    padding: 30px 23px 15px 23px;
    justify-content: space-between;
    background-color: #fff;
    span {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      &:nth-child(1) {
        color: rgba(153, 153, 153, 1);
      }
      &:nth-child(2) {
        font-size: 36px;
        color: #333333;
      }
      &:nth-child(3) {
        color: rgba(153, 153, 153, 1);
        color: #0d9869;
      }
    }
  }
  .managerName {
    height: 88px;

    background-color: #f3f3f3;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0 15px 20px 15px;

    color: rgba(87, 87, 87, 1);
    border-radius: 6px;
  }
  .people {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    padding: 26px 20px 36px 0;
    li {
      height: 88px;
      width: 30%;
      background-color: #f3f3f3;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;
      margin-left: 23px;
      color: rgba(87, 87, 87, 1);
      border-radius: 6px;
    }
  }
  .ch {
    color: #fff !important;
    background-color: #0d9869 !important;
  }
}
</style>
